import { SYS_SPACE_FIXED_250 } from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';

export const DriveTrainFilterStyle = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 16px;

	.filter-title {
		margin-top: ${SYS_SPACE_FIXED_250};
		color: ${(props) => props.theme.sys.color.text.copy.default};
	}

	.filter-section {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.filters-container {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		gap: 8px;
	}
`;
